import { render } from "./history-section.vue?vue&type=template&id=3647c8a5&scoped=true&ts=true"
import script from "./history-section.vue?vue&type=script&lang=ts"
export * from "./history-section.vue?vue&type=script&lang=ts"

import "./history-section.vue?vue&type=style&index=0&id=3647c8a5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3647c8a5"]])

export default __exports__